import { portalAction, portalScreenContext } from '../../../../app/telemetry/portalTelemetry';
import { Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { getDateWithMonthName, getLocalDate } from '../../../../app/utils/util';
import { CreditRecord } from '../../models/creditRecord';
import { AppPathEnum } from '../../../../app/enums/appPathEnum';
import { useAppSelector } from '../../../../app/store/configureStore';
import { useState } from 'react';
import AppPagination from '../../../../app/components/AppPagination';
import { CpdRecordStatusEnum } from '../../../../app/enums/cpdRecordStatusEnum';

export default function CpdDataList() {
  const { cpdCategories, activityTypes, cpdRecordStatuses } = useAppSelector(state => state.ReferenceData);
  const { creditRecords, documents } = useAppSelector(state => state.credits);
  const [startIndexForGrid, setStartIndexForGrid] = useState(0);
  const [endIndexForGrid, setEndIndexForGrid] = useState(0);

  const getCpdStatusColor = (cpdRecordStatusId: string) => {
    return cpdRecordStatuses?.find(x => x.id === cpdRecordStatusId)?.code === CpdRecordStatusEnum.RequiresFurtherAction ? '#FFBF00' : 'white';
  }

  return <>
    <Grid container rowSpacing={3} columnSpacing={1} sx={{ fontSize: 15, paddingRight: '20px' }}>

      <Grid size={{ xs: 5, sm: 1.5 }} display={{ xs: 'block' }}><b>Date of activity</b></Grid>

      <Grid size={{ xs: 1.5, sm: 2 }} display={{ xs: 'none', sm: 'block' }}><b>Category</b></Grid>

      <Grid size={{ xs: 5, sm: 2 }} display={{ xs: 'block' }}><b>Activity type</b></Grid>

      <Grid size={{ xs: 2.5, sm: 2 }} display={{ xs: 'none', sm: 'block' }}><b>Activity description</b></Grid>

      <Grid size={{ xs: 1.5, sm: 1 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}><b>Credits</b></Grid>

      <Grid size={{ xs: 1.5 }} display={{ xs: 'none', sm: 'block' }}><b>Status</b></Grid>

      <Grid size={{ xs: 1 }} display={{ xs: 'none', sm: 'block' }}><b>No. of documents attached</b></Grid>

      <Grid size={{ xs: 2, sm: 0.5 }} display={{ xs: 'block' }}></Grid>
    </Grid>

    {creditRecords?.slice(startIndexForGrid, endIndexForGrid)?.map((row: CreditRecord) => (
      <Grid key={row.creditRecordId} container rowSpacing={3} columnSpacing={1}
        sx={{ backgroundColor: getCpdStatusColor(row.cpdRecordStatusId), fontSize: 15, paddingRight: '15px', padding: '5px' }}>
        <Grid size={{ xs: 5, sm: 1.5 }} display={{ xs: 'block' }}>
          {new Date(row.activityDate).getFullYear() !== 1 ?
            getDateWithMonthName(getLocalDate(row.activityDate)) : ''}
        </Grid>

        <Grid size={{ xs: 1.5, sm: 2 }} display={{ xs: 'none', sm: 'block' }}>
          {cpdCategories?.find(x => x.id === row.cpdCategoryId)?.value}
        </Grid>

        <Grid size={{ xs: 5, sm: 2 }} display={{ xs: 'block' }}>
          {activityTypes?.find(x => x.id === row.activityTypeId)?.value}
        </Grid>

        <Grid size={{ xs: 2.5, sm: 2 }} display={{ xs: 'none', sm: 'block' }}>{row.description}</Grid>

        <Grid size={{ xs: 1.5, sm: 1 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>{row.credits}</Grid>

        <Grid size={{ xs: 1.5 }} display={{ xs: 'none', sm: 'block' }}>
          {cpdRecordStatuses?.find(x => x.id === row.cpdRecordStatusId)?.value}
        </Grid>

        <Grid size={{ xs: 1 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
          {documents?.filter(x => x.directory === row.creditRecordId).length}
        </Grid>

        <Grid size={{ xs: 2, sm: 0.5 }} display={{ xs: 'block' }}>
          <Button component={Link} to={`${AppPathEnum.PCS_VIEW_CPD}/${row.creditRecordId}`} size="small" onClick={portalAction(portalScreenContext('CpdDataList'), 'CpdDataList.navigate', () => { })}>View</Button>
        </Grid>
      </Grid>
    ))}

    {creditRecords?.length === 0 &&
      <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
        No data found.
      </Grid>
    }

    <Grid size={{ xs: 12 }}></Grid>
    <Grid size={{ xs: 12 }}></Grid>

    <AppPagination startIndex={(data: number) => setStartIndexForGrid(data)}
      endIndex={(data: number) => setEndIndexForGrid(data)} recordsCount={creditRecords?.length ?? 0} />
  </>
}